import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const TagRemoveIcon: React.FC<IProps> = props => {
	const { className, fillColor } = props;
	return (
		<SvgIcon height={24} width={24} viewBox='0 0 24 24' className={`${className || ''}`}>
			<g fill='none' fillRule='evenodd' id='Page-1' stroke='none' strokeWidth='1'>
				<g transform='translate(0, -1)' fill={fillColor || '#757575'}>
					<g transform='translate(12, 13) scale(-1, 1) translate(-12, -13)translate(0, 1)'>
						<path d='M15,7 C16.104,7 17,6.104 17,5 C17,3.895 16.104,3 15,3 C13.894,3 13,3.895 13,5 C13,6.104 13.894,7 15,7' />
						<path d='M8,17.5859 L2.414,11.9999 L12.414,1.9999 L18,1.9999 L18,7.5859 L17.793,7.7929 L19.208,9.2069 L19.707,8.7069 C19.894,8.5199 20,8.2649 20,7.9999 L20,0.9999 C20,0.4479 19.552,-0.0001 19,-0.0001 L12,-0.0001 C11.735,-0.0001 11.481,0.1059 11.293,0.2929 L0.293,11.2929 C-0.098,11.6839 -0.098,12.3159 0.293,12.7069 L7.293,19.7069 C7.488,19.9019 7.744,19.9999 8,19.9999 L8,17.5859 Z' />
						<path d='M17,12 C14.243,12 12,14.243 12,17 C12,19.757 14.243,22 17,22 C19.757,22 22,19.757 22,17 C22,14.243 19.757,12 17,12 M17,24 C13.14,24 10,20.86 10,17 C10,13.14 13.14,10 17,10 C20.86,10 24,13.14 24,17 C24,20.86 20.86,24 17,24' />
					</g>
					<polygon points='10 19 4 19 4 17 10 17' />
				</g>
			</g>
		</SvgIcon>
	);
};
